import { useMutation, useQueryClient } from '@tanstack/react-query';

import { raiseEvent } from '@cast/analytics';
import { getApiClient } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

import { notifyReportingMonetizationApiError } from './reportingMonetizationRedirect';
import { getReportingTrialStatusQueryKey } from './useReportingTrialStatusQuery';

export const useConfirmReportingCheckoutSessionMutation = () => {
  const queryClient = useQueryClient();
  const { currentOrganization } = useOrganizations();

  return useMutation({
    mutationFn: (checkoutSessionId: string) =>
      getApiClient().costReport.confirmReportingMonetizationCheckoutSession({
        body: { checkoutSessionId },
      }),
    onSuccess: (response, checkoutSessionId) => {
      const payload = response.data;
      if (payload.paid) {
        raiseEvent({
          title: 'reporting_payment_succeeded',
          type: 'reporting_monetization',
          source: 'checkout_confirm',
          checkout_id: checkoutSessionId,
          selected_plan: payload.tier,
        });
        notify.success('Payment confirmed. Your reporting plan is active.');
      }
      queryClient.invalidateQueries({
        queryKey: getReportingTrialStatusQueryKey(currentOrganization?.id),
      });
    },
    onError: (error) => {
      notifyReportingMonetizationApiError(error, 'confirm checkout');
    },
  });
};
